import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'repvisits.upgrade.form.header',
    defaultMessage: 'to Intersect Presence and get the most out of RepVisits',
  },
  upgrade: {
    id: 'repvisits.upgrade.form.upgrade',
    defaultMessage: 'Upgrade',
  },
  contactInformation: {
    id: 'repvisits.upgrade.form.contactInformation',
    defaultMessage: 'Verify your contact information below',
  },
  unlockPowerfulFeatures: {
    id: 'repvisits.upgrade.form.unlockPowerfulFeatures',
    defaultMessage: 'Unlock powerful features',
  },
  planAndOrganize: {
    id: 'repvisits.upgrade.form.planAndOrganize',
    defaultMessage: 'Plan and organize your travel more efficiently with the Travel Plan',
  },
  recommendations: {
    id: 'repvisits.upgrade.form.recommendations',
    defaultMessage: 'Make smarter, data-driven decisions with Recommendations',
  },
  contacts: {
    id: 'repvisits.upgrade.form.contacts',
    defaultMessage: 'Manage your RepVisits contacts in one place with Contacts',
  },
  optimizeTravel: {
    id: 'repvisits.upgrade.form.optimizeTravel',
    defaultMessage: 'Optimize travel by viewing the availability of multiple high schools at once',
  },
  andMore: {
    id: 'repvisits.upgrade.form.andMore',
    defaultMessage: '… and more!',
  },
  representative: {
    id: 'repvisits.upgrade.form.representative',
    defaultMessage: 'A representative will walk you through everything you want to know and discuss pricing.',
  },
  requestInformation: {
    id: 'repvisits.upgrade.form.requestInformation',
    defaultMessage: 'Request Information',
  },
  closingCount: {
    id: 'repvisits.upgrade.form.closing',
    defaultMessage: 'Closing in {count, number} secs..',
  },
  thanksTitle: {
    id: 'repvisits.upgrade.form.thanksTitle',
    defaultMessage: 'Thanks!',
  },
  thanksMessage: {
    id: 'repvisits.upgrade.form.thanksMessage',
    defaultMessage: 'We\'ll be reaching out to you soon.',
  },
  planAndOrganizeAlt: {
    id: 'repvisits.upgrade.form.planAndOrganizeAlt',
    defaultMessage: 'Plan and organize your travel more efficiently',
  },
  recommendationsAlt: {
    id: 'repvisits.upgrade.form.recommendationsAlt',
    defaultMessage: 'Make smarter and data driven decisions',
  },
  contactsAlt: {
    id: 'repvisits.upgrade.form.contactsAlt',
    defaultMessage: 'Contacts all in one place',
  },
  optimizeTravelAlt: {
    id: 'repvisits.upgrade.form.optimizeTravelAlt',
    defaultMessage: 'Optimize travel',
  },
  successAlt: {
    id: 'repvisits.upgrade.form.successAlt',
    defaultMessage: 'We will be in touch shortly',
  },
  enterValue: {
    id: 'repvisits.upgrade.form.error.missingValue',
    defaultMessage: 'Please enter a value',
  },
  note: {
    id: 'repvisits.upgrade.note',
    defaultMessage: 'Note: Upgrades are available for U.S. and Canadian based institutions only.',
  },
  firstName: {
    id: 'repvisits.upgrade.form.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'repvisits.upgrade.form.lastName',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'repvisits.upgrade.form.emailAddress',
    defaultMessage: 'Email',
  },
  invalidEmail: {
    id: 'repvisits.upgrade.form.error.emailInvalid',
    defaultMessage: 'Invalid email address',
  },
  phone: {
    id: 'repvisits.upgrade.form.phone',
    defaultMessage: 'Phone',
  },
  invalidPhone: {
    id: 'repvisits.upgrade.form.error.phoneInvalid',
    defaultMessage: 'Invalid phone number',
  },
  company: {
    id: 'repvisits.upgrade.form.company',
    defaultMessage: 'Institution',
  },
  notes: {
    id: 'repvisits.upgrade.form.message',
    defaultMessage: 'Please provide more information to help us better route your request.',
  },
  hobsonsCommunication: {
    id: 'repvisits.upgrade.form.optIn',
    defaultMessage: 'Receive Intersect communications related to product news, promotions, event updates, and company announcements.',
  },
  formErrors: {
    id: 'repvisits.upgrade.form.errors',
    defaultMessage: 'There are form errors',
  },
  jobLevel: {
    id: 'repvisits.upgrade.form.job.level',
    defaultMessage: 'Job Level',
  },
  jobTopic: {
    id: 'repvisits.upgrade.form.job.topic',
    defaultMessage: 'Are you interested in upgrading to a paid subscription or support for an existing subscription?',
  },
});

export default messages;
